// extracted by mini-css-extract-plugin
export default {"dropdownSelect":"Tia-z","disabled":"Uia-z","dropdownList":"Via-z","highlightedOption":"Wia-z","outOfStockOption":"Xia-z","selectedOption":"Yia-z","dropdownOption":"Zia-z"};